/**
 * @description Примесь сохранения файла.
 * @type {Object}
 */
export default {
  methods: {
    /**
     * @description Сохранить файл.
     * @param {Blob}    file Файл.
     * @param {string} name Название файла.
     */
    saveFile(file, name) {
      const obj = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = obj;
      link.target = '_blank';
      link.download = name;
      link.click();
      URL.revokeObjectURL(link.href);
      link.remove();
    },
  },
};
